/* eslint-disable eqeqeq */
import BackendLayout from "../../layouts/BackendLayout";
import {useDispatch, useSelector} from "react-redux";
import getPageBreadcrumb from "../../services/BreadcrumbServices";
import {UNFINISHED_ACTION_LIST, REGISTER_TREATMENT, INSPECTION_STATUS} from "../../constants/routes";
import CustomSpan from "../../components/CustomSpan";
import CalendarIcon from "../../assets/icons/calendar-big-icon.svg";
import PageEditIcon from "../../assets/icons/page-edit-icon.svg";
import React, {useEffect, useRef, useState} from "react";
import NetWorkIcon from "../../assets/icons/search-screen-machine-group-icon.png";
import {useParams, useLocation} from "react-router-dom";
import {getRegisterTreatmentPageSettings} from "../../api/setting/pageApi";
import {setPageSettings} from "../../store/actions/pageActions";
import {getInformationTreatment, register} from "../../services/treatment/RegisterTreatment";
import {errorStatusHandle} from "../../utils/error-utils";
import {useDocumentTitle, useTableInspectionItemsScroll} from "../../hooks";
import StepBar from "../../components/StepBar";
import {PageTitle} from "../../components/admin";
import Table from "../../components/table/Table";
import {hasErrorInput, getFileIdsFromEditor} from "../../utils";
import {
  TextInput,
  Label,
  CheckboxInput,
  FormGroupInput,
  RemarkDetail,
  DatetimePicker,
  ButtonBack,
  Button,
  ButtonDPad,
  JudgmentLimit, RedirectAlert,
} from "../../components";
import Select2 from "../../components/Select2";
import store from "../../store";
import {getSelectedValue} from "../../utils/select-utils";
import {
  resetAlert,
  setRegisterInspectionAlertError,
  setAlertError,
  setButtonProcessing,
  clearButtonProcessing,
  setAlertSuccess
} from "../../store/actions";
import {HTTP_ERROR_CODES} from "../../constants/error";
import {useNavigate} from 'react-router-dom';
import PageAlert from '../../components/alerts/PageAlert';
import {formatDate, formatDateTime} from "../../utils/datetime-utils";
import SettingIcon from "../../assets/icons/setting-big-icon.svg";
import {smoothScrollToTop} from "../../utils/common-utils";
import tenkenTheme from "../../configs/themes/tenkenTheme";
import {LiaEditSolid} from "react-icons/lia";
import {
  BUTTON_REGISTER_TREATMENT,
} from "../../constants/buttons";
import {
  clearPageLoading,
  setPageLoading
} from '../../store/actions';
import TextEditor from "../../components/form/inputs/TextEditor";
import {
  getBackgroundSymbol,
  getInspectionUnit
} from "../../utils/display-utils";
import {updateUserSetting} from "../../services/user-master/UserSettingServices";
import {USER_SETTING_CATEGORIES} from "../../constants/app";
import TooltipComment from "../../components/TooltipComment"
import {TREATMENT_PAGE} from "../../constants/pageName";
import useRedirectPage from "../../hooks/useRedirectPage";

export default function RegisterTreatmentPage() {
  useRedirectPage(TREATMENT_PAGE);
  const stepBarItems = [
    {spanText: '処置未完了リスト', hasPassed: true},
    {spanText: '処置', isActive: true}
  ];
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {inspectionId} = useParams();
  const location = useLocation();
  const auth = store.getState().auth;
  const tableRef = useRef(null);
  const [treatment, setTreatment] = useState([]);
  const [canEdit, setCanEdit] = useState(true);
  const [inspectionItem, setInspectionItem] = useState([]);
  const [inspection, setInspection] = useState({});
  const [errorMessagesRegister, setErrorMessagesRegister] = useState([]);
  const [formRegister, setFormRegister] = useState({
    treatment_user_id: auth.user.id
  });
  const [listIdItemNG, setListIdItemNG] = useState([]);
  const groupSetting = useSelector((s) => s.app_settings.machine_group);
  const [commentFiles, setCommentFiles] = useState([]);
  const [commentImagesThumb, setCommentImagesThumb] = useState([]);
  const [hasResultOK, setHasResultOK] = useState(false);

  const formatDisplayUser = (user) => {
    return `${user.name} (${user.username})`
  };
  const resultSymbolSetting = useSelector(
    (s) => s.app_settings.inspection_display.inspection_result_symbol
  );
  const treatmentUserOption = [{value: auth.user.id, label: formatDisplayUser(auth.user)}];
  const maxHeightTable = useTableInspectionItemsScroll(tableRef, inspectionItem, hasResultOK);


  useEffect(() => {
    const successMessage = localStorage.getItem('successMessage');
    if (successMessage) {
      dispatch(setAlertSuccess(successMessage));
      localStorage.removeItem('successMessage')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setRegisterTreatmentPageSettings(inspectionId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inspectionId]);

  const handleCheckBoxChange = (key, value) => {
    setFormRegister(prev => {
      const newFormRegister = {...prev};
      if (newFormRegister[key] === value) {
        newFormRegister[key] = '';
      } else {
        newFormRegister[key] = value;
      }
      return newFormRegister;
    });
  };

  const handleInputChange = (key, value) => {
    setFormRegister(prev => ({
      ...prev,
      [key]: value
    }))
  };

  const setRegisterTreatmentPageSettings = async (inspectionId) => {
    dispatch(setPageLoading());
    try {
      const pageSettings = await getRegisterTreatmentPageSettings();
      dispatch(setPageSettings(pageSettings));

      const informationTreatment = await getInformationTreatment(inspectionId);
      formRegister['treatment_datetime'] = pageSettings.datetime;
      const listInspectionItem = informationTreatment.data.inspection.result_inspection;
      setCanEdit(informationTreatment.data.can_edit);
      if (!informationTreatment.data.can_edit) {
        dispatch(setAlertError('すでに承認済みの点検表です。'))
      }

      setTreatment(informationTreatment.data.inspection.inspection_treatment);
      setInspection(informationTreatment.data.inspection);
      setInspectionItem(listInspectionItem);
      if (pageSettings.user_setting?.setting) {
        setHasResultOK(pageSettings.user_setting?.setting?.checked_ok);
      }

      const idsNGResult = listInspectionItem.filter(item => !item.result).map(item => item.inspection_item.id);
      setListIdItemNG(idsNGResult);

      const updatedForm = listInspectionItem.reduce((acc, item, index) => {
        acc[`inspection_item_${item.inspection_item.id}`] = item.inspection_item_value;
        return acc;
      }, {...formRegister});
      setFormRegister(updatedForm);
    } catch (e) {
      errorStatusHandle(e);
    } finally {
      dispatch(clearPageLoading());
    }
  };

  const firstInputIndex = inspectionItem.findIndex(item => item.inspection_item.inspection_item_type.name === 'input');

  const handleSelectChange = (selectOption, name) => {
    var value = '';
    if (selectOption) {
      value = selectOption.value
    }

    setFormRegister({
      ...formRegister,
      [name]: value
    })
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(setButtonProcessing(BUTTON_REGISTER_TREATMENT));
    try {
      const formData = new FormData();
      Object.keys(formRegister).forEach(key => {
        if (key.startsWith('inspection_item_')) {
          const itemId = key.split('_').pop();
          if ((!hasResultOK && listIdItemNG.includes(Number(itemId))) || hasResultOK) {
            formData.append(key, formRegister[key] !== null ? formRegister[key] : '');
          }
        } else {
          formData.append(key, formRegister[key] !== null ? formRegister[key] : '');
        }
      });

      if (formRegister?.remark_text) {
        const fileIdsInEditor = getFileIdsFromEditor(formRegister.remark_text);
        const filteredFiles = commentFiles.filter(file => fileIdsInEditor.includes(file.id));
        const filteredImagesThumb =  commentImagesThumb.filter(file => fileIdsInEditor.includes(file.id));

        filteredFiles.forEach((file) => {
          formData.append('comment_file_ids', file.id);
          formData.append('comment_files', file.file);
        });

        filteredImagesThumb.forEach((file) => {
          formData.append('comment_images_thumb', file.file);
          formData.append('comment_image_thumb_ids', file.id);
        });
      }

      const response = await register(inspectionId, formData);
      const updateSettingsResponse = await updateSettings();
      if (updateSettingsResponse && updateSettingsResponse.sucesss) {
        if (response.result_inspection) {
          localStorage.setItem('success_message', response.message);
          navigate(UNFINISHED_ACTION_LIST);
        } else {
          localStorage.setItem('successMessage', response.message);
          window.location.reload();
        }
      }
    } catch (e) {
      errorStatusHandle(e);
      if (e.status === HTTP_ERROR_CODES.BAD_REQUEST) {
        let responseData = e.data;
        dispatch(setRegisterInspectionAlertError(responseData));
        setErrorMessagesRegister(responseData.errors)
      }
      smoothScrollToTop();
    } finally {
      dispatch(clearButtonProcessing(BUTTON_REGISTER_TREATMENT));
    }
  };

  const handleButtonBack = () => {
    dispatch(resetAlert());
    if (location?.state?.type === 'inspectionStatus') {
      navigate(INSPECTION_STATUS)
    } else {
      if (location?.state?.data) {
        navigate(UNFINISHED_ACTION_LIST, {state: location.state.data})
      } else {
        navigate(UNFINISHED_ACTION_LIST)
      }
    }
  };

  const updateSettings = async () => {
    try {
      return await updateUserSetting({checked_ok : hasResultOK}, USER_SETTING_CATEGORIES.REGISTER_TREATMENT);
    } catch (e) {
      errorStatusHandle(e);
      if (e.status === 400) {
        setErrorMessagesRegister(e.data)
      }
    }
  };

  const breadcrumb = getPageBreadcrumb(REGISTER_TREATMENT);
  useDocumentTitle("処置 - 点検王");
  return (
    <BackendLayout breadcrumb={breadcrumb}>
      <StepBar stepBarItems={stepBarItems}/>
      <PageTitle title="処置"/>
      <ButtonDPad/>
      <div className="w-full flex flex-col justify-start xl:gap-[24px] gap-[18px] flex-1 lg:mt-10 mt-8">
        <RedirectAlert className="!mb-0" />
        <PageAlert className="!mb-0"/>
        <div className="flex items-center 2xl:gap-5 xl:4 lg:gap-3 gap-2 2xl:pr-0 pr-6 w-fit">
          <div className="flex items-center w-fit xl:px-[16px] xl:py-[8px] px-[12px] py-[4px] rounded-lg bg-white border border-[#E0E0E0] gap-[8px]">
            {groupSetting?.group_1?.active && (
              <div className="flex flex-col min-w-[110px] w-fit">
                <Label
                  className="font-normal !mt-0 text-[#616161] whitespace-nowrap"
                  text={groupSetting?.group_1?.name}
                />
                <CustomSpan
                  text={inspection?.group?.group_1?.name || "-"}
                  className="font-medium truncate lg:max-w-[220px] max-w-[208px]"
                  title={inspection?.group?.group_1?.name || "-"}
                />
              </div>
            )}
            {groupSetting?.group_2?.active && (
              <div className="flex flex-col min-w-[110px] w-fit">
                <Label
                  className="font-normal !mt-0 text-[#616161] whitespace-nowrap"
                  text={groupSetting?.group_2?.name}
                />
                <CustomSpan
                  text={inspection?.group?.group_2?.name || "-"}
                  className="font-medium truncate lg:max-w-[220px] max-w-[208px]"
                  title={inspection?.group?.group_2?.name || "-"}
                />
              </div>
            )}

            {groupSetting?.group_3?.active && (
              <div className="flex flex-col min-w-[110px] w-fit">
                <Label
                  className="font-normal !mt-0 text-[#616161] whitespace-nowrap"
                  text={groupSetting?.group_3?.name}
                />
                <CustomSpan
                  text={inspection?.group?.group_3?.name || "-"}
                  className="font-medium truncate lg:max-w-[220px] max-w-[208px]"
                  title={inspection?.group?.group_3?.name || "-"}
                />
              </div>
            )}

            {groupSetting?.group_4?.active && (
              <div className="flex flex-col min-w-[110px] w-fit">
                <Label
                  className="font-normal !mt-0 text-[#616161] whitespace-nowrap"
                  text={groupSetting?.group_4?.name}
                />
                <CustomSpan
                  text={inspection?.group?.group_4?.name || "-"}
                  className="font-medium truncate lg:max-w-[220px] max-w-[208px]"
                  title={inspection?.group?.group_4?.name || "-"}
                />
              </div>
            )}

            {groupSetting?.group_5?.active && (
              <div className="flex flex-col min-w-[110px] w-fit">
                <Label
                  className="font-normal !mt-0 text-[#616161] whitespace-nowrap"
                  text={groupSetting?.group_5?.name}
                />
                <CustomSpan
                  text={inspection?.group?.group_5?.name || "-"}
                  className="font-medium truncate lg:max-w-[220px] max-w-[208px]"
                  title={inspection?.group?.group_5?.name || "-"}
                />
              </div>
            )}
            <img src={NetWorkIcon} alt="Net work Icon"
                 className="xl:w-[40px] xl:h-[42px] min-w-[36px] h-[38px]"></img>
          </div>
          <div
            className="flex items-center justify-between xl:px-[16px] px-[12px] xl:py-[8px] w-full max-w-[260px] py-[4px] border border-[#E0E0E0] bg-white rounded-lg min-w-[200px] xl:min-w-[230px]">
            <div className="flex flex-col xl:text-[16px] md:text-[15px] w-[80%] relative">
              <CustomSpan
                className="text-[#616161] font-medium"
                text="設備No."/>
              <span className="font-medium truncate w-full block"
                    title={inspection?.machine?.name}>{inspection?.machine?.name}</span>
            </div>
            <img src={SettingIcon} alt="Setting Icon"
                 className="xl:w-[40px] xl:h-[42px] w-[36px] h-[38px]"></img>
          </div>
          <div
            className="flex items-center justify-between xl:px-[16px] px-[12px] xl:py-[8px] w-full max-w-[260px] py-[4px] border border-[#E0E0E0] bg-white rounded-lg min-w-[200px] xl:min-w-[230px] 2xl:min-w-[260px]">
            <div className="flex flex-col xl:text-[16px] md:text-[15px]">
              <CustomSpan
                className="text-[#616161] font-medium"
                text="点検テンプレート名"
              />
              <span className="font-medium truncate 2xl:w-[200px] xl:w-[160px] w-[150px] block"
                    title={inspection?.template?.name}>{inspection?.template?.name}</span>
            </div>
            <img src={PageEditIcon} alt="Page Edit Icon"
                 className="xl:w-[40px] xl:h-[42px] w-[36px] h-[38px]"></img>
          </div>
          <div
            className="flex items-center justify-between xl:px-[16px] px-[12px] xl:py-[8px] w-full max-w-[260px] py-[4px] border border-[#E0E0E0] bg-white rounded-lg min-w-[200px] xl:min-w-[230px]">
            <div className="flex flex-col xl:text-[16px] md:text-[15px]">
              <CustomSpan
                className="text-[#616161] font-medium"
                text="実施日"/>
              <CustomSpan className="font-medium whitespace-nowrap"
                          text={formatDate(new Date())}/>
            </div>
            <img src={CalendarIcon} alt="Calendar Icon"
                 className="xl:w-[40px] xl:h-[42px] w-[36px] h-[38px]"></img>
          </div>
        </div>
        <div className="flex flex-col w-full max-w-[1674px] min-w-[1120px] xl:gap-[24px] gap-[18px]">
          <div className='flex flex-col gap-[8px]'>
            <div className="flex justify-between">
              <CustomSpan text="処置情報を入力してください" className="tenken__text-gray-900"/>
              <div className="flex justify-end items-center">
                <CheckboxInput name="has_inspected" id="has_inspected"
                               label="結果OKの点検項目を表示に含める"
                               onChange={() => setHasResultOK(!hasResultOK)}
                               checked={hasResultOK}
                               classLabel="tenken__text-gray-900">
                </CheckboxInput>
              </div>
            </div>
            <div className="w-full relative rounded-lg border border-[#e0e0e0] overflow-y-auto" style={{
              maxHeight: maxHeightTable ? `${maxHeightTable}px` : "auto"
            }} ref={tableRef}>
              <Table className="no-drop-shadow-table" striped>
                <Table.Head className={`${maxHeightTable ? 'sticky top-0 z-[8]' : ''}`}>
                  <Table.HeadCell
                    className="!normal-case w-[76px]"
                  >
                    <span>No.</span>
                  </Table.HeadCell>
                  <Table.HeadCell
                  >
                    <span className="whitespace-nowrap">点検項目</span>
                  </Table.HeadCell>
                  <Table.HeadCell
                  >
                    <span className="whitespace-nowrap">判定基準</span>
                  </Table.HeadCell>
                  <Table.HeadCell>
                    <span className="inline-block min-w-[40px] whitespace-nowrap">下限</span>
                  </Table.HeadCell>
                  <Table.HeadCell>
                    <span className="inline-block min-w-[40px] whitespace-nowrap">上限</span>
                  </Table.HeadCell>
                  <Table.HeadCell>
                  </Table.HeadCell>
                  <Table.HeadCell
                  >
                    <span className="whitespace-nowrap">留意事項</span>
                  </Table.HeadCell>
                  <Table.HeadCell className="2xl:w-[320px] xl:w-[240px] w-[200px]">
                    <span className="whitespace-nowrap">点検結果</span>
                  </Table.HeadCell>
                </Table.Head>
                <Table.Body className="devide-y text-base">
                  {inspectionItem && inspectionItem.length > 0 ? (
                    inspectionItem.map((item, index) => {
                      if (!hasResultOK && item.result) {
                        return null;
                      }
                      return (
                        <Table.Row key={index}>
                          <Table.Cell>
                            <span>{item.inspection_item.item_order}</span>
                          </Table.Cell>
                          <Table.Cell className="max-w-[400px]">
                            <span
                              className="break-all"
                              style={{color: item.inspection_item.title_color}}
                            >
                              {item.inspection_item.title}
                            </span>
                          </Table.Cell>
                          <Table.Cell className="max-w-[300px]">
                            <span
                              className="break-all"
                              style={{color: item.inspection_item.description_color}}
                            >
                              {item.inspection_item.description}
                            </span>
                          </Table.Cell>
                          <Table.Cell className="max-w-[300px]">
                            <JudgmentLimit
                              value={item.inspection_item?.inspection_judgment?.lower_value}
                              boundaryType={item.inspection_item?.inspection_judgment?.lower_boundary_type}
                              unit={item.inspection_item?.unit}
                              type="lower"
                            />
                          </Table.Cell>
                          <Table.Cell className="max-w-[300px]">
                            <JudgmentLimit
                              value={item.inspection_item?.inspection_judgment?.upper_value}
                              boundaryType={item.inspection_item?.inspection_judgment?.upper_boundary_type}
                              unit={item.inspection_item?.unit}
                              type="upper"
                            />
                          </Table.Cell>
                          <Table.Cell>
                          <span
                            title={item.inspection_item?.unit}
                            className="whitespace-nowrap"
                          >
                            {item.inspection_item?.unit ? getInspectionUnit(item.inspection_item?.unit, true) : '-'}
                          </span>
                          </Table.Cell>
                          <Table.Cell>
                            <RemarkDetail key={index} rowData={item.inspection_item}/>
                          </Table.Cell>
                          <Table.Cell>
                            {item.inspection_item?.inspection_item_type?.name === 'checkbox' && (
                              <div className="flex items-center 2xl:gap-[32px] xl:gap-[28px] gap-[24px]">
                                <CheckboxInput name={`inspection_item_${item.inspection_item.id}`}
                                               id={`inspection_item_OK_${item.inspection_item.id}`}
                                               value="OK"
                                               disabled={!canEdit}
                                               onChange={() => handleCheckBoxChange(`inspection_item_${item.inspection_item.id}`, 'OK')}
                                               checked={formRegister[`inspection_item_${item.inspection_item.id}`] === 'OK'}
                                               label={resultSymbolSetting['passed'].symbol}
                                               labelStyle={{
                                                 color: resultSymbolSetting.passed.color,
                                                 background: getBackgroundSymbol(resultSymbolSetting, 'passed')
                                               }}
                                               classLabel="xl:text-[20px] text-[18px]">
                                </CheckboxInput>

                                <CheckboxInput name={`inspection_item_${item.inspection_item.id}`}
                                               id={`inspection_item_NG_${item.inspection_item.id}`}
                                               value="NG"
                                               disabled={!canEdit}
                                               onChange={() => handleCheckBoxChange(`inspection_item_${item.inspection_item.id}`, 'NG')}
                                               checked={formRegister[`inspection_item_${item.inspection_item.id}`] === 'NG'}
                                               label={resultSymbolSetting['failed'].symbol}
                                               labelStyle={{
                                                 color: resultSymbolSetting.failed.color,
                                                 background: getBackgroundSymbol(resultSymbolSetting, 'failed')
                                               }}
                                               classLabel="xl:text-[20px] text-[18px] text-[#D92D20]">
                                </CheckboxInput>
                              </div>
                            )}
                            {item.inspection_item?.inspection_item_type?.name === 'input' && (
                              <div className="flex">
                                <FormGroupInput className="items-center relative w-full">
                                  {getInspectionUnit(item.inspection_item.unit) !== "" ? (
                                    <>
                                      <TextInput name={`inspection_item_${item.inspection_item.id}`} type="text"
                                                 autoFocus={index === firstInputIndex}
                                                 readOnly={!canEdit}
                                                 disabled={!canEdit}
                                                 onChange={(e) => handleInputChange(`inspection_item_${item.inspection_item.id}`, e.target.value)}
                                                 value={formRegister[`inspection_item_${item.inspection_item.id}`] || ''}
                                                 hasError={hasErrorInput(errorMessagesRegister, `inspection_item_${item.inspection_item.id}`)}
                                                 className="w-full tenken__text-gray-900 min-w-[200px] max-w-[280px] focus:ring-0 focus:border-[#D0D5DD] bg-white 2xl:pl-[14px] 2xl:pr-[104px] 2xl:py-[10px] xl:pl-[12px] xl:pr-[96px] xl:py-[8px] md:pl-[10px] md:pr-[40px] md:py-[6px] rounded-lg border border-[#D0D5DD]"/>
                                      <CustomSpan
                                        title={item.inspection_item.unit}
                                        className="absolute right-3 2xl:text-[16px] tenken__text-gray-900 xl:text-[15px] md:text-[14px]"
                                      >
                                        {getInspectionUnit(item.inspection_item.unit)}
                                      </CustomSpan>
                                    </>
                                  ) : (
                                    <>
                                      <TextInput name={`inspection_item_${item.inspection_item.id}`} type="text"
                                                   autoFocus={index === firstInputIndex}
                                                   readOnly={!canEdit}
                                                   disabled={!canEdit}
                                                   onChange={(e) => handleInputChange(`inspection_item_${item.inspection_item.id}`, e.target.value)}
                                                   value={formRegister[`inspection_item_${item.inspection_item.id}`] || ''}
                                                   hasError={hasErrorInput(errorMessagesRegister, `inspection_item_${item.inspection_item.id}`)}
                                                   className="w-full tenken__text-gray-900 min-w-[200px] max-w-[280px] focus:ring-0 focus:border-[#D0D5DD] bg-white 2xl:px-[14px] 2xl:py-[10px] xl:px-[12px] xl:py-[8px] md:px-[10px] md:py-[6px] rounded-lg border border-[#D0D5DD]"/>
                                    </>
                                  )}
                                </FormGroupInput>
                              </div>
                            )}
                          </Table.Cell>
                        </Table.Row>
                      )
                    })
                  ) : (
                    null
                  )}
                </Table.Body>
              </Table>
            </div>

          </div>
          <div className="relative rounded-lg border border-[#e0e0e0]">
            <Table className="no-drop-shadow-table" striped>
              <Table.Head className="whitespace-nowrap">
                <Table.HeadCell
                  className="w-[43%]"
                >
                  <span>処置履歴</span>
                </Table.HeadCell>
                <Table.HeadCell
                >
                </Table.HeadCell>
              </Table.Head>
              <Table.Body className="devide-y text-base whitespace-nowrap">
                {treatment.length > 0 && (
                  treatment.map((item, index) => (
                    <>
                      <Table.Row key={index}>
                        <Table.Cell>
                          <span className="tenken__text-gray-900">処置担当者（{item.treatment_number}回目）</span>
                        </Table.Cell>
                        <Table.Cell>
                          <span className="tenken__text-gray-900">{formatDisplayUser(item.treatment_user)}</span>
                        </Table.Cell>
                      </Table.Row>
                      <Table.Row key={index}>
                        <Table.Cell>
                          <span className="tenken__text-gray-900"> 処置日時（{item.treatment_number}回目)</span>
                        </Table.Cell>
                        <Table.Cell>
                        <span
                          className="tenken__text-gray-900">{formatDateTime(new Date(item.treatment_datetime))}</span>
                        </Table.Cell>
                      </Table.Row>
                    </>
                  ))
                )}
                <Table.Row>
                  <Table.Cell>
                    <span className="tenken__text-gray-900">処置担当者（{treatment.length + 1}回目）</span>
                  </Table.Cell>
                  <Table.Cell>
                    <Select2
                      options={treatmentUserOption}
                      className="xl:text-base text-gray-900 2xl:w-[320px] xl:w-[300px] lg:w-[280px] md:w-[260px] tenken__text-gray-900"
                      classNamePrefix="react-select"
                      maxLength={20}
                      isDisabled={!canEdit}
                      onChange={(treatmentUserOption) => handleSelectChange(treatmentUserOption, 'treatment_user_id')}
                      value={getSelectedValue(treatmentUserOption, formRegister['treatment_user_id'] || auth.user.id)}
                      placeholder=''
                      name="treatment_user_id"
                      hasError={hasErrorInput(errorMessagesRegister, 'treatment_user_id')}
                    />
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>
                    <span className="tenken__text-gray-900"> 処置日時（{treatment.length + 1}回目)</span>
                  </Table.Cell>
                  <Table.Cell>
                    <DatetimePicker name="treatment_datetime"
                                    id='treatment_datetime'
                                    onChange={handleInputChange}
                                    maxLength={16}
                                    disabled={!canEdit}
                                    value={formRegister['treatment_datetime']}
                                    hasError={hasErrorInput(errorMessagesRegister, 'treatment_datetime')}
                                    className="tenken__text-gray-900 2xl:w-[320px] xl:w-[300px] lg:w-[280px] md:w-[260px] 2xl:px-[14px] 2xl:py-[10px] xl:px-[12px] xl:py-[8px] md:px-[10px] md:py-[6px] rounded-lg border border-[#D0D5DD] focus:ring-0 focus:border-[#D0D5DD]">
                    </DatetimePicker>
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </div>
          <div
            className="flex flex-col 2xl:p-[24px] xl:p-[16px] md:p-[12px] bg-[#FFF] justify-center item-center rounded-lg  border border-[#e0e0e0] w-full xl:gap-[20px] gap-[12px]">
            <div className="flex items-center">
              <Label className="font-medium mr-[4px]" text="処置コメント"/>
              <TooltipComment isDisplay={canEdit} isTreatment={true}/>
            </div>
            <TextEditor
              onChange={handleInputChange}
              name="remark_text"
              canEdit={canEdit}
              setCommentFiles={setCommentFiles}
              setCommentImagesThumb={setCommentImagesThumb}
            />
          </div>

          <div className="flex items-center py-[10px] 2xl:gap-[120px] xl:gap-[100px] md:gap-[80px] justify-center">
            <ButtonBack onClick={() => handleButtonBack()}/>
            <Button type="submit" theme={tenkenTheme.button} color="primary" onClick={(e) => handleSubmit(e)}
                    disabled={!canEdit}
                    id={BUTTON_REGISTER_TREATMENT} className="rounded-lg border min-w-[280px] h-[40px]">
              <LiaEditSolid className="text-white font-medium mr-[2px]" size={20}/>
              登録
            </Button>
          </div>
        </div>
      </div>
    </BackendLayout>
  );
}